import {Component, OnInit} from '@angular/core';
import {CoreService, ProleisObject} from "proleis-rest-client";
import {ActivatedRoute} from "@angular/router";
import {exhaustMap, Observable} from "rxjs";
import {RedirectService} from "../../../services/redirect.service";

@Component({
  selector: 'app-nc-program',
  templateUrl: './nc-program.component.html',
  styleUrls: ['./nc-program.component.scss']
})
export class NcProgramComponent implements OnInit {
  ncProgram$: Observable<ProleisObject>;
  ncFileObjects$: Observable<ProleisObject[]>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private coreService: CoreService,
    private redirectService: RedirectService
  ) {
  }

  ngOnInit() {
    this.loadProgram();
    this.loadNcFileObjects();
  }

  loadProgram() {
    const aliasFields =
      'NCPROGS=$JOIN(NCFILES, ",")' +
      ';POS_ID=PARENT[$ISPROJECTNODE=false].OBJECT_ID;POS_NAME=PARENT[$ISPROJECTNODE=false].TEXT' +
      ';BEMI_ID=PARENT[$ISPROJECTNODE=true].OBJECT_ID;BEMI_NAME=PARENT[$ISPROJECTNODE=true].TEXT;' +
      'PART_ID=PARENT[TYP_ID.GUID=b514dea4-27fa-11b2-800a-b390cd5bbe84].OBJECT_ID;PART_NAME=PARENT[TYP_ID.GUID=b514dea4-27fa-11b2-800a-b390cd5bbe84].TEXT;' +
      'PROJECT_ID=PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84];PROJECT_NAME=PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].TEXT';
    this.ncProgram$ = this.coreService.getObjectById<ProleisObject>(this.activatedRoute.snapshot.params.ncprogramId, aliasFields);
  }

  loadNcFileObjects() {
    const aliasFields = 'SENDSTATUS=CALC_SENDSTATUS_ID.TEXT';
    this.ncFileObjects$ = this.ncProgram$.pipe(
      exhaustMap((clamping) => {
        const params = {
          IDS: clamping.NCPROGS,
        };
        return this.coreService.getObjectsQuery<ProleisObject[]>(
          'getObjectsById',
          params,
          aliasFields
        );
      }),
    );
  }

  redirect(id: string) {
    this.redirectService.redirectToInfoPanel(id);
  }
}
